import React, { useEffect, useRef, useState } from "react";
import logo from "../../images/logo.png";
import bgvideo from "../../images/bgvideo.mp4";
import facebook from "../../images/facebook.svg";
import google from "../../images/google.svg";
import twitterfill from "../../images/twitter-fill.svg";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { callApi } from "../common/API/Api";
import { useNavigate } from "react-router-dom";
import { getBaseUrl } from "../common/BaseUrl";

const Resetpassword = () => {
  document.title =   "Equlix";
  let base_url = getBaseUrl()
  const [resetpassword, setResetpassword] = useState();
  const [loading, setLoading] = useState(false);
    const { email, token } = useParams()
  console.log(token, "token")
  const navigate = useNavigate();
  const [showpassword, setShowpassword] = useState({
    password: false,
    confirmpassword: false,
  });
  const [validmessage, setvalidmessage] = useState({
    password: "",
    confirmpassword: "",
    matchpassword: "",
    error: "",
    success: "",
  });
  const allsignupdata = (key, value) => {
    setResetpassword((state) => ({
      ...state,
      [key]: value,
    }));
  };
  const signupvalidction = (resetpassword) => {
    if (!resetpassword?.password) {
      setvalidmessage((state) => ({
        ...state,
        password: "Password is Required",
        error: "",
        success: "",
      }));
      return;
    } else {
      setvalidmessage((state) => ({
        ...state,
        password: "",
      }));
    }
    if (!resetpassword?.confirmpassword) {
      setvalidmessage((state) => ({
        ...state,
        confirmpassword: "Confirmpassword is Required",
        error: "",
        success: "",
      }));
      return;
    } else {
      setvalidmessage((state) => ({
        ...state,
        confirmpassword: "",
      }));
    }
    if (resetpassword?.password !== resetpassword?.confirmpassword) {
      setvalidmessage((state) => ({
        ...state,
        matchpassword: "Passwords do not match.",
        error: "",
        success: "",
      }));
      return;
    } else {
      setvalidmessage((state) => ({
        ...state,
        matchpassword: "",
      }));
    }
    updatepassword(resetpassword);
  };
  const updatepassword = async (resetpassword) => {
    try {
        setLoading(true);
        setvalidmessage((state) => ({
            ...state,
            success: "",
            error:""
          }));
      let data = { ...resetpassword };
      delete data.confirmpassword;
      const formData = new FormData();
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          formData.append(key, data[key]);
        }
      }
      let postdata = formData;
      let res = await callApi(postdata, `api/reset-passwords`, "POST");
      if (res?.data?.success) {
        navigate(`${base_url}login`);
        setvalidmessage((state) => ({
          ...state,
          success: res?.data?.message,
        }));
      } else {
        setvalidmessage((state) => ({
          ...state,
          error: res?.data?.message,
        }));
      }
    } catch (err) {
      console.log(err, "err");
    }finally {
        setLoading(false);
      }
  };
  useEffect(()=>{

    setResetpassword((state)=>({
        ...state,
        token: token,
        email:email
    }))
  },[])
  const videoRef = useRef(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const handleVideoEnd = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0; 
        videoRef.current.play(); 
      }
      setIsTransitioning(false); 
    }, 100); 
  };

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const handleTimeUpdate = () => {
        if (video.duration - video.currentTime <= 1) {
          setIsTransitioning(true); 
        }
      };
      video.addEventListener('timeupdate', handleTimeUpdate);
      video.addEventListener('ended', handleVideoEnd); 
      video.play();
      return () => {
        video.removeEventListener('timeupdate', handleTimeUpdate);
        video.removeEventListener('ended', handleVideoEnd);
      };
    }
  }, []);
  return (
    <div className="theme-color-1">
      <div className="mainLoginbg">
      <div style={{ position: 'relative', overflow: 'hidden' }}>
     
     {/* Video element */}
     <video
       ref={videoRef}
       playsInline
       loop={false} 
       muted
       autoPlay
       style={{ width: '100%', height: '100%', objectFit: 'cover', opacity :!isTransitioning ? 1 : 0 ,      transition: 'opacity 1s ease-in-out', }}
     >
       <source src={bgvideo} type="video/mp4" />
     </video>

     <div
       style={{
         position: 'absolute',
         top: 0,
         left: 0,
         width: '100%',
         height: '100%',
         backgroundColor: 'black',
         opacity: isTransitioning ? 1 : 0,
         transition: 'opacity 1s ease-in-out', 
         pointerEvents: 'none', 
       }}
     />
   </div>
        {/* <video playsInline loop muted autoPlay>
          <source src={bgvideo} type="video/mp4" />
        </video> */}

        <section className="loginRegisterform maxwidth">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-md-8">
                <div className="site_logo">
                  <Link to={`${base_url}`}>
                    <img src={logo} alt="" />
                  </Link>
                </div>

                <form action="#">
                  <div className="form-title">
                    <h4>Reset Password</h4>
                  </div>
                      <div className="form-group">
                        <input
                          value={resetpassword?.password}
                          onChange={(e) =>
                            allsignupdata("password", e.target.value)
                          }
                          type={showpassword?.password ? "text" : "password"}
                          className={
                            validmessage?.password ||
                            validmessage?.matchpassword
                              ? "form-control border-danger"
                              : "form-control"
                          }
                          placeholder="Password"
                        />
                        <i
                          onClick={() =>
                            setShowpassword((state) => ({
                              ...state,
                              password: !showpassword?.password,
                            }))
                          }
                          className={`toggle-password fa-regular fa-fw ${
                            showpassword?.password ? "fa-eye" : "fa-eye-slash"
                          }`}
                        ></i>
                        {validmessage?.password ? (
                          <p className="p-0 text-danger">
                            {validmessage?.password}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="form-group">
                        <input
                          value={resetpassword?.confirmpassword}
                          onChange={(e) =>
                            allsignupdata("confirmpassword", e.target.value)
                          }
                          type={
                            showpassword?.confirmpassword ? "text" : "password"
                          }
                          className={
                            validmessage?.confirmpassword ||
                            validmessage?.matchpassword
                              ? "form-control border-danger"
                              : "form-control"
                          }
                          placeholder="Confirm Password"
                        />
                        <i
                          onClick={() =>
                            setShowpassword((state) => ({
                              ...state,
                              confirmpassword: !showpassword?.confirmpassword,
                            }))
                          }
                          className={`toggle-password fa-regular fa-fw ${
                            showpassword?.confirmpassword
                              ? "fa-eye"
                              : "fa-eye-slash"
                          }`}
                        ></i>
                        {validmessage?.confirmpassword ||
                        validmessage?.matchpassword ? (
                          <p className="p-0 text-danger">
                            {validmessage?.confirmpassword
                              ? validmessage?.confirmpassword
                              : validmessage?.matchpassword}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                
                  {validmessage?.error  ? (
                    <p className="p-0 text-danger">{validmessage?.error}</p>
                  ) : (
                    ""
                  )}
                     {validmessage?.success  ? (
                    <p className="p-0 text-success">{validmessage?.success}</p>
                  ) : (
                    ""
                  )}
                  {loading ? (
                    <button
                      type="button"
                      className="btn bg_btn"
                    >
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>{" "}
                    </button>
                  ) : (
                    <button
                    type="button"
                    className="btn bg_btn"
                    onClick={() => signupvalidction(resetpassword)}
                  >
                  Reset Password{" "}
                  </button>
                  )}
                
                  {/* <p>
                    Already have an account?{" "}
                    <Link to="/equlixweb/login">Log in</Link>
                  </p> */}
                  {/* <div className="borderline"></div>
                  <div className="or">Or</div> */}

                  {/* <div className="social_icon">
                    <Link to="" onClick={(e)=>e.preventDefault()}>
                      <img src={facebook} alt="" /> Facebook
                    </Link>
                    <Link to="" onClick={(e)=>e.preventDefault()}>
                      <img src={google} alt="" /> Google
                    </Link>
                    <Link to="" onClick={(e)=>e.preventDefault()}>
                      <img src={twitterfill} alt="" /> Twitter
                    </Link>
                   <a href="javascript:;"><img src="images/app.svg"></a>  
                  </div> */}
                </form>
              </div>
              {/*  <div className="col-xl-6 col-md-6">
                     <div className="loginCard">
                        <img src="images/signup-bg.png">
                        <div className="shorttext">
                           <h4>Enjoy a $500 Welcome Gift when you sign up!</h4>
                           <p>New to Equlix? Make your first deposit and start trading to claim up to $500!</p>
                           <p>*T&C apply.</p>
                        </div>
                     </div>
                  </div>  */}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Resetpassword;
